import Copyright from '../../components/Copyright';
import Layout from '../../pages/Layout';
import PageProgress from './PageProgress';
import { Page } from '../enums';
import { getCurrentPage } from '../utils';

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export default function LayoutWrapper({ children }: LayoutWrapperProps) {
  const currentPage = getCurrentPage();
  const isUnableToServicePage = currentPage === Page.UnableToService;

  return (
    <Layout>
      <div className="md:hidden mt-8">
        <PageProgress />
      </div>
      <div className="md:mt-[60px] mt-[26px]">
        <div
          className={`md:shadow-[0px_20px_36px_-8px_rgba(0,0,0,0.1),_0px_1px_2px_rgba(0,0,0,0.05)] bg-white rounded-xl md:rounded-2xl px-6 md:px-10 py-8 md:py-[60px] md:w-[805px] mx-0 md:mx-auto ${
            isUnableToServicePage ? '' : 'md:min-h-[580px]'
          }`}>
          <div className="hidden md:block">
            <PageProgress />
          </div>
          {children}
        </div>
        <Copyright />
      </div>
    </Layout>
  );
}
